import { render, staticRenderFns } from "./AvailableHourForm.vue?vue&type=template&id=0188c226"
import script from "./AvailableHourForm.vue?vue&type=script&lang=ts"
export * from "./AvailableHourForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports